import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[_c(VContainer,{attrs:{"fluid":""}},[_c(VLayout,{staticClass:"justify-center",attrs:{"wrap":""}},[_c(VFlex,{attrs:{"xs12":"","sm10":"","md7":""}},[_c('h3',{staticClass:"text-center"},[_vm._v("Informed Choice")]),_vm._v(" "),_c(VCard,[_c(VCardText,[_c('documentation')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }